import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/feature/SectionTitle';
import { indexCategories } from '@/mocks/indexNav';

type IndexNavProps = {
  active: string;
  onSelect: (id: string) => void;
};

export default function IndexNav({ active, onSelect }: IndexNavProps) {
  return (
    <section id="index" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <SectionTitle
            kicker="Core Index"
            title="黑料索引导航 · 一区目录总入口"
            desc="十个常设分类构成完整目录骨架，点选任一分类即可在下方短讯列表中快速筛选，条目随更新同步归档。"
            action={{ label: '查看指引目录', href: '#guide' }}
          />
        </Reveal>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
          {indexCategories.map((category, index) => {
            const isActive = active === category.id;
            return (
              <Reveal key={category.id} delay={index * 40}>
                <button
                  type="button"
                  onClick={() => onSelect(category.id)}
                  className={`group flex h-full w-full flex-col gap-3 rounded-lg border p-4 text-left cursor-pointer transition-colors ${
                    isActive
                      ? 'border-primary-500 bg-primary-500 text-background-50'
                      : 'border-background-200 bg-background-50 text-foreground-950 hover:border-primary-300 hover:bg-primary-50'
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <span
                      className={`flex h-10 w-10 items-center justify-center rounded-md ${
                        isActive ? 'bg-background-50/15 text-background-50' : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      <i className={`${category.icon} text-lg`} />
                    </span>
                    <span
                      className={`font-label text-xs ${
                        isActive ? 'text-accent-200' : 'text-foreground-500 group-hover:text-primary-600'
                      }`}
                    >
                      {category.count.toLocaleString('en-US')}
                    </span>
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-bold">{category.name}</h3>
                    <p className={`mt-1 text-xs leading-relaxed ${isActive ? 'text-background-100/80' : 'text-foreground-600'}`}>
                      {category.desc}
                    </p>
                  </div>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}